<template>
  <div class="home-page">
    <!--  -->
  </div>
</template>

<script>
import HomeChart from '@modules/home/components/home-chart.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'app-home-page',

  components: {
    [HomeChart.name]: HomeChart,
  },

  created() {
    if (this.isMobile) this.collapseMenu();
  },

  mounted() {
    if (this.currentManage.type === 'admin') return;
    if (this.$route.path === '/') this.$router.push('/?go');
  },

  computed: {
    ...mapGetters({
      isMobile: 'layout/isMobile',
      currentManage: 'auth/manage/currentManage',
    })
  },

  methods: {
    ...mapActions({
      collapseMenu: 'layout/collapseMenu',
    })
  }
};
</script>

<style scoped>
.el-col {
  margin-bottom: 16px;
}

.home-bottom-message {
  width: 100%;
  text-align: center;
  color: grey;
}
</style>
